seedWebApp.directive('previewHtml', ['$compile', function ($compile) {
    return {
        restrict: 'A',
        replace: true,
        link: function (scope, ele, attrs) {
            scope.$watch(attrs.previewHtml, function (html) {
                ele.html(html);
                $compile(ele.contents())(scope);
            });
        }
    };
}]);